import { organizationsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useDisableOrganization = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    organizationsRepo.disableOrganization(id),
  );
